import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { openSentFile } from "@/components/SentDocumentsPanel";

// Feste Stufe je Versandart; Rechnungen nach Rechnungsart (passend zu den Stufennamen).
const KIND_STAGE = {
  order_confirmation_pdf: "order_confirmation_sent",
  order_confirmation: "order_confirmation_sent",
  bza_package: "bza_requested",
  bza_request: "bza_requested",
  customer_bza_package: "order_confirmed",
  final_invoice: "commissioning",
};
const INVOICE_STAGE = {
  AZ1: "first_az_sent", AZ2: "installation_start", AZ2_COMBINED: "installation_start",
  AZ3: "commissioning", SR: "commissioning", SZ: "commissioning",
};
const INVOICE_KINDS = ["down_payment_invoice", "down_payment_invoice_resend"];
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("de-DE", {
  day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

// Versendete Dokumente (aus dem Versandarchiv) gruppiert nach Tracker-Stufe.
export function useStageSentFiles(projectId, invoices, reloadKey) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!projectId) return;
    api.get(`/projects/${projectId}/sent-documents`)
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]));
  }, [projectId, reloadKey]);

  return useMemo(() => {
    const byId = Object.fromEntries((invoices || []).map((i) => [i.id, i]));
    const out = {};
    items.forEach((it) => {
      if (!it.ok) return;
      let stage = KIND_STAGE[it.kind];
      if (INVOICE_KINDS.includes(it.kind)) {
        const inv = byId[it.invoice_id] || (invoices || []).find((i) => i.invoice_number && (it.subject || "").includes(i.invoice_number));
        stage = INVOICE_STAGE[String(it.invoice_kind || inv?.kind || "AZ1").toUpperCase()] || "first_az_sent";
      }
      if (!stage) return;
      (it.files || []).filter((f) => f.available).forEach((f) => {
        (out[stage] = out[stage] || []).push({
          key: `${it.id}-${f.idx}`,
          filename: f.filename,
          sublabel: `an ${it.recipient_email || "—"} · ${fmt(it.sent_at)}`,
          onOpen: () => openSentFile(projectId, it.id, f.idx),
        });
      });
    });
    return out;
  }, [items, invoices, projectId]);
}
